import BaseModel from '../../base';

export default class TaskSettings extends BaseModel {
  constructor(settings = {}, url) {
    super(settings, url);

    this.is_moderated = settings.is_moderated || false;
    this.is_online = settings.is_online || false;
    this.is_appeal = settings.is_appeal || false;
    this.passing_score = settings.passing_score || false;
    this.minutes_to_solve = settings.minutes_to_solve || 0;
    this.issuance_tags = settings.issuance_tags || [];
    this.asked_question_count = settings.asked_question_count || null;
  }
}
